module.exports = function ({langId = 2} = {}) {
	const url = `/templetify/static?t=mainPage/header/brandMessage&langId=${langId}`;
	return (`
<!--# include virtual="${url}" -->
`)
};
